// eslint-disable-next-line import/prefer-default-export
export enum AlertType {
  Info = 0,
  Warning = 1,
  Error = 2,
  Success = 3,
}
